var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdaptive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000856",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 124.7,
    y1: 170.7,
    x2: 124.7,
    y2: 198.8,
    gradientTransform: "translate(183.9 220.1) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7187e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b198f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: -47.4,
    y1: -64.9,
    x2: -47.4,
    y2: -58.9,
    gradientTransform: "translate(65 102.3)",
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-3",
    x1: -12.7,
    y1: -80.5,
    x2: -12.7,
    y2: -74.4,
    gradientTransform: "translate(65 102.3)",
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-4",
    x1: 0.3,
    y1: -57.7,
    x2: 0.3,
    y2: -51.6,
    gradientTransform: "translate(65 102.3)",
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-5",
    x1: 36.4,
    y1: -72.2,
    x2: 36.4,
    y2: -66.1,
    gradientTransform: "translate(65 102.3)",
    xlinkHref: "#Degradado_sin_nombre_4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,69.6c11.2,1.6,15.5-5.9,32.8-1,13.8,3.9,20.8-5.2,23.2-11.1,1.1-2.8,2.4-14.1-5.3-15-26.2-3-44.5-34.3-59.5-9.8-6.1,9.9-16.4,33.2,8.9,36.9Z",
    style: {
      fill: "#b198f8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.3,62.3c-1.2,0-2.3,0-3.5-.2-6.3-.6-12.2-2.8-17.3-6.2s-8.6-3.7-13.3-3-5.8,.6-8.8,.6H9.8c-1.6,0-2.9-1.3-2.9-2.9V29.5c0-1.6,1.3-2.9,2.9-2.9h14.7c0,0,.1,0,.2,0,2.7,0,5-2,5.7-4.6s2.1-5.3,4-7.6c4.5-5.3,11.6-7.8,18.5-6.4,8.3,1.7,14.5,8.4,15.4,16.8,.3,2.5,0,4.9-.5,7.2s1.3,3.4,3.1,2.7,2.3-1.2,3.3-2.1c8.7-8.1,19.7-13.2,31.5-13.2h4.5c1.6,0,2.9,1.3,2.9,2.9v21.2c0,1.6-1.3,2.9-2.9,2.9h-4.4c-4.6,0-9,1.8-12.3,5.1-7,7-16.4,10.9-26.2,10.9Z",
    style: {
      fill: "#fff",
      filter: "url(#drop-shadow-2)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.3,34.7c-7.3,0-14.1,2.8-19.3,8-4.9,4.9-11.6,7.3-18.4,6.6-7.8-.7-14.7-5.5-18.3-12.3l-1.2,.6c-5.6,2.6-11.6,3.8-17.8,3.8h-7.1v-2.6h7.1c5.8,0,11.5-1.2,16.8-3.6l1.2-.6c0,0,0-.1,0-.2l-1.5-4.1c-.9-2.3-.4-4.8,1.2-6.7,1.3-1.5,3.1-2.4,5.1-2.4s.9,0,1.4,.1c2.9,.6,5,2.9,5.3,5.8,.3,2.9-1.2,5.6-3.9,6.9l-4,1.8c3.2,6,9.3,10.2,16.2,10.8,6.1,.6,12-1.6,16.3-5.9,5.6-5.6,13.1-8.7,21.1-8.7v2.6Zm-54.7-1.2l4-1.8c2-.9,2.6-2.8,2.4-4.2-.2-1.4-1.1-3.1-3.3-3.6-1.5-.3-2.9,.2-3.9,1.4-1,1.1-1.3,2.7-.7,4.1l1.5,4.1h0Z",
    style: {
      fill: "url(#Degradado_sin_nombre_4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 40.4,
    r: 3,
    style: {
      fill: "url(#Degradado_sin_nombre_4-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.3,
    cy: 24.9,
    r: 3,
    style: {
      fill: "url(#Degradado_sin_nombre_4-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.4,
    cy: 47.7,
    r: 3,
    style: {
      fill: "url(#Degradado_sin_nombre_4-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.4,
    cy: 33.2,
    r: 3,
    style: {
      fill: "url(#Degradado_sin_nombre_4-5)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptive);
export default __webpack_public_path__ + "static/media/adaptive.3cd700cea15b6fbabb088d891b80cbcc.svg";
export { ForwardRef as ReactComponent };